import React from 'react';
import { Card, CardBody, CardHeader, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { H5, P } from '../../../../../AbstractElements';
import { Add, border_tab, Hometxt, Inbox, MaterialLeftTab, Modalcontent, Pillspan1, Profile, Settings } from '../../../../../Constant';
import TabsPreventDefaultAndAnimation from '../../../../../Hoc/TabsPreventDefaultAndAnimation';

const LeftTab = ({ show, tabActive, tabActiveHandler }) => {
  return (
    <Col sm='12' xl='6 xl-100'>
      <Card>
        <CardHeader className='pb-0'>
          <H5>{MaterialLeftTab}</H5>
          <span>
            {Add} <code>{border_tab}</code> {Pillspan1}
          </span>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm='3' className='tabs-responsive-side'>
              <Nav className='flex-column nav-pills border-tab nav-left'>
                <NavItem>
                  <NavLink href='#javascript' className={tabActive === '1' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '1')}>
                    {Hometxt}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href='#javascript' className={tabActive === '2' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '2')}>
                    {Profile}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href='#javascript' className={tabActive === '3' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '3')}>
                    {Inbox}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href='#javascript' className={tabActive === '4' ? 'active' : ''} onClick={(e) => tabActiveHandler(e, '4')}>
                    {Settings}
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col sm='9'>
              <TabContent activeTab={tabActive}>
                <TabPane className={`fade ${tabActive === '1' ? show : ''}`} tabId='1'>
                  <P>{Modalcontent}</P>
                </TabPane>
                <TabPane className={`fade ${tabActive === '2' ? show : ''}`} tabId='2'>
                  <P>{Modalcontent}</P>
                </TabPane>
                <TabPane className={`fade ${tabActive === '3' ? show : ''}`} tabId='3'>
                  <P>{Modalcontent}</P>
                </TabPane>
                <TabPane className={`fade ${tabActive === '4' ? show : ''}`} tabId='4'>
                  <P>{Modalcontent}</P>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TabsPreventDefaultAndAnimation(LeftTab);
